'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _TypeContext = require('../editors/TypeContext');

var _reactFulcrum = require('@upgrowth/react-fulcrum');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = (0, _TypeContext.withTypes)(function (_ref) {
  var _ref$layout = _ref.layout,
      layout = _ref$layout === undefined ? {} : _ref$layout,
      values = _ref.values,
      addOptions = _ref.addOptions,
      variant = _ref.variant,
      onRemove = _ref.onRemove,
      onReorder = _ref.onReorder;
  var _layout$columns = layout.columns,
      columns = _layout$columns === undefined ? 'auto-fill' : _layout$columns,
      _layout$width = layout.width,
      width = _layout$width === undefined ? 'minmax(280px, 1fr)' : _layout$width;
  return _react2.default.createElement('div', {
    className: 'GridLayout variant-' + variant,
    style: {
      gridTemplateColumns: 'repeat( ' + columns + ', ' + width + ')'
    }
  }, (0, _lodash.map)(values, function (child) {
    return _react2.default.createElement('div', {
      className: 'GridLayoutCell',
      key: child.key
    }, child.el, _react2.default.createElement('div', {
      className: 'actions'
    }, onRemove && _react2.default.createElement(_reactFulcrum.Button, {
      className: 'action-remove',
      onClick: function onClick() {
        return onRemove(child.key);
      }
    }, '-')));
  }), addOptions && _react2.default.createElement('div', {
    className: 'GridLayoutCell add'
  }, addOptions));
});